import { render, staticRenderFns } from "./pageHeader.vue?vue&type=template&id=56cf21dd&scoped=true&"
import script from "./pageHeader.vue?vue&type=script&lang=js&"
export * from "./pageHeader.vue?vue&type=script&lang=js&"
import style0 from "./pageHeader.vue?vue&type=style&index=0&id=56cf21dd&lang=scss&scoped=true&"
import style1 from "./pageHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cf21dd",
  null
  
)

export default component.exports